/**
* Web Service handler to retrieve and represent a list of Resource Sets
*
* @class ResourceSetWS
*/
var ResourceSetWS = function (parent) {
	var self = this; // Convenience reference so the context of 'this' becomes clearer

	// Predicate this Web Service handler on the Abstract class of a Web
	// Service handler. This establishes core functionality required of
	// these such handlers, which can be overwritten by methods below.
	AbstractWS.apply( this, arguments );

	self.assignments		= ko.observableArray( [] )
	self.dataType			= 'json';
	self.delAssocId			= null;
	self.endpoint			= ko.observable( null );
	self.endpoints			= {
								'add' : {
									endpoint: '/qless/api/v1/employee/calendar/resourceselection/add',
									method: 'POST'
								},
								'assign' : {
									endpoint: '/qless/api/v1/employee/calendar/resourceselection/assignauth',
									method: 'POST'
								},
								'delete' : {
									endpoint: '/qless/api/v1/employee/calendar/resourceselection/delete',
									method: 'POST'
								},
								'deleteAssoc': {
									endpoint: '/qless/api/v1/employee/calendar/resourceselection/authassignment/delete',
									method: 'POST'
								},
								'get' : {
									endpoint: '/qless/api/v1/employee/calendar/resourceselections',
									method: 'GET'
								},
								'list' : {
									endpoint: '/qless/api/v1/employee/calendar/resourceselection/authassignments',
									method: 'GET'
								}
							};
	self.mode				= ko.observable( null );
	self.name				= 'ResourceSetWS';			// Convenience name for debugging
	self.sendType			= 'application/x-www-form-urlencoded; charset=UTF-8'; // Forces headers to send
	self.sets				= ko.observableArray( [] );



	// Specifies this service's API endpoint
	self.serviceURL	= ko.computed( function () {
		return self.endpoint();
	});


	/**
	* Pushes a new Resource Selection to the service
	*
	* @method addResourceSet
	* @param {Array} resourceIds
	* @param {String} name
	* @param {String} description
	* @return none
	*/
	self.addResourceSet = function ( resourceIds, name, description ) {

		// Set the mode in case the process data method needs to handle the return
		// differently
		self.mode( 'add' );

		// Handle resourceIds being passed as either an array or a string
		if ( typeof resourceIds == 'object' ) {
			resourceIds = resourceIds.join(',');
		}

		// Set the payload
		self.params = {
			name: name,
			description: description || name,
			resources: resourceIds
		};

		// Do IT!
		self.doRequest();
	};


	/**
	* Creates a join between a resourceSet and an oauth
	*
	* @method assign
	* @param {Number} iResourceSetId
	* @param {Number} iOAuthId
	* @return none
	*/
	self.addAssociation = function ( iResourceSetId, iOAuthId ) {
		// Set the mode in case the process data method needs to handle the return
		// differently
		self.mode( 'assign' );

		// Set the payload
		self.params = {
			credentialId: iOAuthId,
			selectionId: iResourceSetId
		};

		// Do IT!
		self.doRequest();
	};


	/**
	* Abstract override allows for object set-up before request
	*
	* @method doRequest
	* @return none
	*/
	self.doRequest = function ( fCallback ) {
		// Pull the connection details for this particular mode
		var endP = self.endpoints[ self.mode() ];

		// Set the endpoint, which will get pulled in serviceURL
		self.endpoint( endP.endpoint );

		// Set the XMLHttpRequest method
		self.method( endP.method );

		// Do IT!
		AbstractWS.prototype.doRequest.call( self, fCallback );
	};


	/**
	* Pulls all known resource selections for the user
	*
	* @method get
	* @return none
	*/
	self.getResourceSets = function ( fCallback ) {
		// Set the mode in case the process data method needs to handle the return
		// differently
		self.mode( 'get' );

		// Do IT!
		self.doRequest( fCallback );
	};


	/**
	* Lists all known associations (OAuth -> ResourceSet)
	*
	* @method getResourceAssociations
	* @return none
	*/
	self.getResourceAssociations = function ( fCallback ) {
		// Set the mode in case the process data method needs to handle the return
		// differently
		self.mode( 'list' );

		// Do IT!
		self.doRequest( fCallback );
	};


	/**
	* Locates a ResourceSet by name
	*
	* @method getSetByName
	* @param {String} sName
	* @return {Object | Null}
	*/
	self.getSetByName = function ( sName ) {
		return self.sets().find( function ( set ) {
			return set.name == sName;
		});
	};


	/**
	* DESCRIPTION
	*
	* @method numResourcePairings
	* @param {Number} iResourceSetId
	* @return none
	*/
	self.numResourcePairings = function ( iResourceSetId ) {
		// '/qless/api/v1/employee/calendar/resourceselection/countassignments?selectionId='+ iResourceSetId;
	};


	/**
	* Removes a ResourceSet from the data store
	*
	* @method remove
	* @param {Number} iSelectionId
	* @return none
	*/
	self.remove = function ( iSelectionId, fCallback ) {
		var selId = iSelectionId;
		// Set the mode in case the process data method needs to handle the return
		// differently
		self.mode( 'delete' );

		// Set the payload
		self.params = {
			selectionIds: selId
		};

		self.delAssocId = null;

		// Do IT!
		//self.doRequest( self.removeAssociation( selId, fCallback ) );
		self.doRequest( fCallback );
	};




	self.removeAssociation = function ( iAssociationId, fCallback ) {
		self.delAssocId = iAssociationId;
		// Set the mode in case the process data method needs to handle the return
		// differently
		self.mode('deleteAssoc');

		// Set the payload
		self.params = {
				id: iAssociationId
		};

		// Do it
		self.doRequest( fCallback );
	};


	/**
	* DESCRIPTION
	*
	* @method resourcePairedToAuto
	* @param {Number} iResourceSetId
	* @param {Number} iOAuthId
	* @return none
	*/
	self.resourcePairedToAuto = function ( iResourceSetId, iOAuthId ) {
		// '/qless/api/v1/employee/calendar/resourceselection/authassignment/count?selectionId='+ iResourceSetId +'&credentialId='+ iOAuthId;
	};


	/**
	* This method pushed the returned authorizations to the observable collection 'auths'
	*
	* @method processData
	* @param {JSON} data JSON data returned from the service
	* @return {ResourceSetWS} Returns the object as chainable, for best practice
	*/
	self.processData = function ( data ) {
		// Temporary variable to contain ResourceSetModels
		var aTemp = [];

		//console.log( self.mode(), data );


		if ( self.mode() == 'deleteAssoc' ) {
			self.remove( self.delAssocId, self.callback );
		}
		else {
			if ( data.resourceSelections ) {

				// If a new resource set was added, it will be returned as an object
				// Turn that object into a new model and append it to the sets collection
				if ( self.mode() == 'add' ) {
					data.resourceSelections.forEach( function ( sel ) {
						aTemp.push( new ResourceSetModel( sel ) );
					});

					// Add the new models to the end of the existing ones
					aTemp = self.sets().concat( aTemp );

					// Update the observableArray once so as to not cause multiple subscription firings
					self.sets( aTemp );

					// Get the selection Id so we can then link this selection set to the selected
					// OAuth ID
					self.addAssociation( data.resourceSelections[0].selectionId, qcal.oauthWS.oAuthSel() );
				}
				// If we have gotten all the resource sets, create new models and replace what is in the sets collection
				else if ( self.mode() == 'get') {
					// Loop over each returned set and push a new ResourceSetModel to the temp array
					data.resourceSelections.forEach( function ( sel ) {
						aTemp.push( new ResourceSetModel( sel ) );
					});

					// Update the observableArray once so as to not cause multiple subscription firings
					self.sets( aTemp );
				}
			}
			else {
				if ( self.mode() == 'list' ) {
					self.assignments( data.resourceSelectionAuthAssignments );

					qcal.oauthWS.endpoint( qcal.oauthWS.endpoints.default );
					qcal.oauthWS.doRequest();
				}
				else if ( self.mode() == 'assign' ) {
					aTemp = self.assignments().concat( data.resourceSelectionAuthAssignments );
					self.assignments( aTemp );

					qcal.iCalConf( true );
				}
			}

			// Call the superclass method to perform any core actions
			AbstractWS.prototype.processData.call( self, data );
		}

		// Return self (ResourceSetWS) to be chainable, for best practice
		return self;
	};


	return self;
};

ResourceSetWS.prototype = AbstractWS.prototype;
ResourceSetWS.prototype.constructor = ResourceSetWS;
